import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HotCategories() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门赛事分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">选择您感兴趣的运动项目，获取专业赛事分析</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-3 rounded-2xl bg-primary-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                {cat.matchCount}场赛事 &middot; {cat.articleCount}篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}